module.exports = __webpack_public_path__ + "static/media/35.aea2b697.wav";